import { render, staticRenderFns } from "./filesInfo.vue?vue&type=template&id=60dcdc20&scoped=true&"
import script from "./filesInfo.vue?vue&type=script&lang=js&"
export * from "./filesInfo.vue?vue&type=script&lang=js&"
import style0 from "./filesInfo.vue?vue&type=style&index=0&id=60dcdc20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dcdc20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCol,VIcon,VListItem,VListItemContent})
